<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col>
            <b-card>
              <template slot="header">
                Welkom {{ userName }}!
              </template>
            </b-card>
          </b-col>
        </b-row>

        <!-- Campaign Name Update Form -->
        <b-row class="mt-4" v-if="userRole==='admin'">
          <b-col>
            <b-card>
              <template slot="header">
                Verkiezingscampagne instellen
              </template>

              <b-form @submit="onSubmit" @reset="onReset">
                <b-form-group
                  id="campaign-name-group"
                  label="Verkiezingscampagne naam:"
                  label-for="campaign-name"
                  description="Voer de nieuwe verkiezingscampagne naam in"
                >
                  <b-form-input
                    id="campaign-name"
                    v-model="form.campaign_name"
                    type="text"
                    placeholder="Bijv. Tweedekamer verkiezingen 2026"
                    required
                    :state="campaignNameState"
                    :disabled="isLoading"
                  ></b-form-input>

                  <b-form-invalid-feedback :state="campaignNameState">
                    Verkiezingscampagne naam is verplicht en moet minimaal 3 karakters bevatten.
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-button-group>
                  <b-button
                    type="submit"
                    variant="primary"
                    :disabled="!isFormValid || isLoading"
                  >
                    <b-spinner small v-if="isLoading"></b-spinner>
                    {{ isLoading ? 'Bijwerken...' : 'Bijwerken' }}
                  </b-button>

                  <b-button
                    type="reset"
                    variant="secondary"
                    :disabled="isLoading"
                  >
                    Reset
                  </b-button>
                </b-button-group>
              </b-form>

              <!-- Success/Error Messages -->
              <b-alert
                v-model="showSuccessAlert"
                variant="success"
                dismissible
                class="mt-3"
              >
                Verkiezingscampagne naam succesvol bijgewerkt!
              </b-alert>

              <b-alert
                v-model="showErrorAlert"
                variant="danger"
                dismissible
                class="mt-3"
              >
                {{ errorMessage }}
              </b-alert>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceTable from '../../components/ResourceTable';
import ResourceFilters from '../../components/ResourceFilters';
import {updateData, getData} from '@/api';

export default {
  name: 'dashboard',
  components: {ResourceTable, ResourceFilters},
  data() {
    return {
      form: {
        campaign_name: ''
      },
      isLoading: false,
      showSuccessAlert: false,
      showErrorAlert: false,
      errorMessage: '',
      originalCampaignName: ''
    }
  },
  computed: {
    userRole() {
      return this.$store.state.userRole
    },
    userName() {
      return this.$store.state.userName
    },
    campaignNameState() {
      return this.form.campaign_name.length >= 3;
    },
    isFormValid() {
      return this.form.campaign_name.length >= 3;
    }
  },
  async mounted() {
    await this.loadCurrentCampaignName();
  },
  methods: {
    async loadCurrentCampaignName() {
      try {
        this.isLoading = true;
        // Adjust the endpoint as needed for your API
        const response = await getData('campaign/current');

        if (response && response.status === 200 && response.data) {
          this.form.campaign_name = response.data.campaign_name || '';
          this.originalCampaignName = this.form.campaign_name;
        }
      } catch (error) {
        console.error('Error loading campaign name:', error);
        this.showError('Fout bij het laden van de huidige verkiezingscampagne naam');
      } finally {
        this.isLoading = false;
      }
    },

    async onSubmit(event) {
      event.preventDefault();

      if (!this.isFormValid) {
        return;
      }

      try {
        this.isLoading = true;
        this.hideAlerts();

        // Prepare the data to send
        const updatePayload = {
          campaign_name: this.form.campaign_name
        };

        // Update the campaign name - adjust endpoint as needed
        const response = await updateData('campaign/update-name', updatePayload);

        if (response && response.status === 200) {
          this.showSuccess();
          this.originalCampaignName = this.form.campaign_name;
        } else {
          const fallbackMessage = (response && response.data && response.data.message) || 'Onbekende fout opgetreden';
          throw new Error(fallbackMessage);
        }

      } catch (error) {
        console.error('Error updating campaign name:', error);
        this.showError(error.message || 'Fout bij het bijwerken van de verkiezingscampagne naam');
      } finally {
        this.isLoading = false;
      }
    },

    onReset(event) {
      event.preventDefault();
      this.form.campaign_name = this.originalCampaignName;
      this.hideAlerts();
    },

    showSuccess() {
      this.showSuccessAlert = true;
      this.showErrorAlert = false;
      // Auto-hide success message after 5 seconds
      setTimeout(() => {
        this.showSuccessAlert = false;
      }, 5000);
    },

    showError(message) {
      this.errorMessage = message;
      this.showErrorAlert = true;
      this.showSuccessAlert = false;
    },

    hideAlerts() {
      this.showSuccessAlert = false;
      this.showErrorAlert = false;
      this.errorMessage = '';
    }
  }
}
</script>
